import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from "reactstrap"
import ProcessModal from "./ProcessModal"
import {processRequest, deleteRequest} from "../../../../../services/api/apiReGenerateLabel"
import DeleteModal from "./DeleteModal"
import PubSub from "pubsub-js"

class ProcessRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            note: '',
            loading: false,
            error: '',
            tooltipOpen: false
        }
    }

    _onOpen = () => {
        this.setState({
            isOpen: true
        })
    }

    _onClose = () => {
        this.setState({
            isOpen: false,
            loading: false,
            error: '',
        })
    }

    _onChangeNote = (value) => {
        this.setState({
            note: value
        })
    }

    _onProcessRequest = async (process) => {
        this.setState({
            loading: process,
            error: ''
        })

        try {
            const {id} = this.props
            const {note} = this.state

            const {data: response} = await processRequest(id, process, {content: note})

            const {success, message} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            this.setState({
                loading: false,
            }, () => {
                const {refreshList} = this.props

                if (typeof refreshList === 'function') {
                    refreshList()
                }

                PubSub.publish('LIST_RE_GENERATE_SIDEBAR')

                this._onClose()
            })
        } catch (error) {
            const {response} = error

            if (!response || typeof response !== 'object') {
                return this.setState({
                    error: error,
                    loading: false
                })
            }

            const {data} = response

            if(typeof data === 'object' && data.hasOwnProperty('message')) {
                return this.setState({
                    error: data.message,
                    loading: false
                })
            }

            this.setState({
                error: error.message,
                loading: false
            })

        }
    }

    _onToggle = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        })
    }

    _onDelete = async (id) => {
        this.setState({
            loading: 'delete',
            error: ''
        })

        try {
            const {data: response} = await deleteRequest(id)

            const {success, message} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            this.setState({
                loading: false
            }, () => {
                const {refreshList} = this.props

                if (typeof refreshList === 'function') {
                    refreshList()
                }

                this._onClose()
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {barcodeNumber, approvedStatus, id, generateStatus, uploadStatus, content} = this.props
        const {isOpen, note, loading, error, tooltipOpen} = this.state

        if (approvedStatus === 'rejected' || uploadStatus !== 'success') {
            return <td className='ProcessingRequest text-center'>
                <i className='fa fa-trash-o text-danger' onClick={this._onOpen}
                   id={'TooltipDelete_' + id}/>
                <Tooltip placement="top" isOpen={tooltipOpen} target={'TooltipDelete_' + id}
                         toggle={this._onToggle}>
                    Xóa
                </Tooltip>
                <DeleteModal
                    id={id}
                    loading={loading}
                    error={error}
                    barcodeNumber={barcodeNumber}
                    note={note}
                    isOpen={isOpen}
                    onClose={this._onClose}
                    onOpen={this._onOpen}
                    onDelete={this._onDelete}
                />
            </td>
        }

        return (
            <td className='ProcessingRequest text-center Actions'>
                {
                    (approvedStatus === 'pending' && generateStatus === 'pending' && uploadStatus === 'success') &&
                    <div className='mr-2 d-inline-block'>
                        <i className='fa fa-check-circle text-success' onClick={this._onOpen}
                           id={'TooltipProcess_' + id}/>
                        <Tooltip placement="top" isOpen={tooltipOpen} target={'TooltipProcess_' + id}
                                 toggle={this._onToggle}>
                            Phê duyệt
                        </Tooltip>
                        <ProcessModal
                            loading={loading}
                            error={error}
                            barcodeNumber={barcodeNumber}
                            content={content}
                            isOpen={isOpen}
                            uploadStatus={uploadStatus}
                            onClose={this._onClose}
                            onOpen={this._onOpen}
                            onProcessRequest={this._onProcessRequest}
                            onChangeNote={this._onChangeNote}
                        />
                    </div>
                }
            </td>
        )
    }
}

ProcessRequest.propTypes = {
    refreshList: PropTypes.func.isRequired,
    approvedStatus: PropTypes.string,
    id: PropTypes.string,
    barcodeNumber: PropTypes.number,
    generateStatus: PropTypes.string,
    uploadStatus: PropTypes.string,
    content: PropTypes.string
}

export default ProcessRequest